module.exports = __webpack_public_path__ + "img/totquestions.7c7bde08.svg";